module.exports = __webpack_public_path__ + "img/phoneIcon.534d9c05.svg";